import { isEmpty } from "ramda";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { jjLogger } from "utils/logUtils";

const useGoogleOptimize = () => {
  const [loading, setLoading] = useState(true);
  const [testValue, setTestValue] = useState({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getTestValue = (testName) => (queryParams.has(testName) ? queryParams.get(testName) : window.GO[testName]);
  const mergeTestValue = (listTests) => {
    if (isEmpty(listTests)) return;

    const tests = {};
    for (let index = 0; index < listTests.length; index += 1) {
      const testName = listTests[index];
      const value = getTestValue(testName);
      if (value !== undefined) {
        tests[testName] = getTestValue(testName);
      }
    }

    setTestValue({ ...tests, ...testValue });
  };

  useEffect(() => {
    jjLogger.logDebug("useGoogleOptimize.js: loading");
    jjLogger.logDebug(loading);
    jjLogger.logDebug("useGoogleOptimize.js: testValue");
    jjLogger.logDebug(JSON.stringify(testValue));
  }, [testValue]);

  const loadTest = (...args) => {
    jjLogger.logDebug("useGoogleOptimize.js: testName");
    jjLogger.logDebug(args);

    if (window.GO) {
      mergeTestValue(args);
      setLoading(false);
    } else {
      const waitForGO = () => {
        document.removeEventListener("GO:done", waitForGO);
        mergeTestValue(args);
        setLoading(false);
      };
      document.addEventListener("GO:done", waitForGO);
    }
  };

  return {
    loading,
    loadTest,
    testValue,
  };
};

export default useGoogleOptimize;
